import { FormlyFieldConfig } from '@ngx-formly/core';
import { AgreementsFormOptions } from './agreements-form-options.interface';
import { isMissingField } from '../../helper-functions/docusign-utils';

// FUNDED DETAILS values are read-only here and only fixable through the calculator
const hasMissingFundedDetails = (field: FormlyFieldConfig): boolean =>
    Object.values(field.model ?? {}).some((f: any) => isMissingField(f) && f.field_group === 'FUNDED DETAILS');

export function getFundedDetailsAgreementFields(
        options: Partial<AgreementsFormOptions>,
        updateAgreement: Boolean,
        customFieldClass: string,
    ): FormlyFieldConfig[] {
    return [
        {  
            fieldGroupClassName: 'row', 
            ...(updateAgreement)
            ?
            {            
                wrappers: ['expansion-panel'],
                props: {
                    label: 'Referral',
                    groupHeading: 'Loan',
                    icon: 'payments',
                    description: 'Payments, dates & disbursement',
                    expanded: false,
                    expClass: 'exp-class'
                },
                expressions: {
                    'props.hasMissing': hasMissingFundedDetails,
                },
            } : {},
            fieldGroup: [
                // Uncomment if BDM's wants it else remove after few weeks
                // // {
                // // key: 'Amount.value',
                // // type: 'missing-value', 
                // // className: customFieldClass,
                // // props: {
                // //     label: 'Amount',
                // //     appearance: 'outline', 
                // //     floatLabel: 'always',
                // //     readonly: true,
                // // },
                // // expressions: {                                                    
                // //     ...(updateAgreement) ?
                // //     {
                // //         'props.required': 'model.Amount?.required',
                // //         'props.textValue': (field: FormlyFieldConfig) => field.model?.Amount?.value,
                // //     }
                // //     :
                // //     {
                // //         hide: (field: FormlyFieldConfig) =>
                // //         field.model?.Amount?.isValid === true,
                // //         },
                // //     }
                // // },      
                // // {
                // // key: 'InterestAPR.value',
                // // type: 'missing-value', // 'missing-value' Will create only text without input
                // // className: customFieldClass,
                // // props: {
                // //     label: 'Interest APR',
                // //     appearance: 'outline', 
                // //     floatLabel: 'always',
                // //     readonly: true,
                // // },
                // // expressions: {                                                          
                // //     ...(updateAgreement) ?
                // //     {
                // //         'props.required': 'model.InterestAPR?.required',
                // //         'props.textValue': (field: FormlyFieldConfig) => field.model?.InterestAPR?.value,
                // //     }
                // //     :
                // //     {
                // //         hide: (field: FormlyFieldConfig) =>
                // //         field.model?.InterestAPR?.isValid === true,
                // //         },
                // //     }
                // // },
                // // {
                // // key: 'PaymentFrequency.value',
                // // type: 'missing-value', 
                // // className: customFieldClass,
                // // props: {
                // //     label: 'Payment Frequency',
                // //     appearance: 'outline', 
                // //     floatLabel: 'always',
                // //     readonly: true,
                // //     textValue: ''
                // // },
                // // expressions: {                                                          
                // //     ...(updateAgreement) ?
                // //     {
                // //         'props.required': 'model.PaymentFrequency?.required',
                // //         'props.textValue': (field: FormlyFieldConfig) => field.model?.PaymentFrequency?.value,
                // //         }
                // //     :
                // //     {
                // //         hide: (field: FormlyFieldConfig) =>
                // //         field.model?.PaymentFrequency?.isValid === true,
                // //         },
                // //     }
                // // },
                // // {
                // // key: 'TermOfLoanMonths.value',
                // // type: 'missing-value', 
                // // className: customFieldClass,
                // // props: {
                // //     label: 'Term Of Loan (Months)',
                // //     appearance: 'outline', 
                // //     floatLabel: 'always',
                // //     readonly: true,
                // //     textValue: ''
                // // },
                // // expressions: {                                                          
                // //     ...(updateAgreement) ?
                // //     {
                // //         'props.required': 'model.TermOfLoanMonths?.required',
                // //         'props.textValue': (field: FormlyFieldConfig) => field.model?.TermOfLoanMonths?.value,
                // //     }
                // //     :
                // //     {
                // //         hide: (field: FormlyFieldConfig) =>
                // //         field.model?.PaymentFrequency?.isValid === true,
                // //         },
                // //     }
                // // },
                {
                key: 'ScheduledPayment.value',
                type: 'agreement-currency', 
                className: customFieldClass,
                props: {
                    label: 'Scheduled Payment',
                    appearance: 'outline', 
                    floatLabel: 'always',
                    readonly: true,
                },
                expressions: {                                                         
                    ...(updateAgreement) ?
                        {
                        'props.required': 'model.ScheduledPayment?.required',
                        'props.textValue': (field: FormlyFieldConfig) => (field.model.HasLPP.value === 'Yes') ? field.model?.LPPScheduledPayment?.value : field.model?.ScheduledPayment?.value,
                        'props.valueSuffix': (field: FormlyFieldConfig) => (field.model?.HasLPP?.value === 'Yes') ? '(incl. LPP)' : '',
                        }
                        :
                        {
                            hide: (field: FormlyFieldConfig) =>
                            field.model?.ScheduledPayment?.isValid === true,
                        },
                    }
                },
                {
                type: 'agreement-lpp-value', 
                className: customFieldClass,
                props: {
                    label: 'LPP',
                    appearance: 'outline', 
                    floatLabel: 'always',
                    readonly: true,
                },
                expressions: {                                                         
                    ...(updateAgreement) ?
                        {
                        hide: (field: FormlyFieldConfig) =>
                        field.model?.HasLPP?.value !== 'Yes',
                        'props.textValue': (field: FormlyFieldConfig) => (field.model.HasLPP.value === 'Yes') ? field.model?.LPPScheduledPayment?.value : field.model?.ScheduledPayment?.value,
                        }
                        :
                        {
                            hide: (field: FormlyFieldConfig) =>
                            field.model?.LoanProtection?.isValid === true,
                        },
                    }
                },
                // // {
                // // key: 'TotalObligationEntireTerm.value',
                // // type: 'agreement-currency', 
                // // className: customFieldClass,
                // // props: {
                // //     label: 'Total Obligation Entire Term',
                // //     appearance: 'outline', 
                // //     floatLabel: 'always',
                // //     readonly: true,
                // // },
                // // expressions: {                                                        
                // //     ...(updateAgreement) ?
                // //     {
                // //         'props.required': 'model.TotalObligationEntireTerm?.required',
                // //         'props.textValue': (field: FormlyFieldConfig) => (field.model.HasLPP.value === 'Yes') ? field.model?.TotalObligationEntireTermWithLPP?.value : field.model?.TotalObligationEntireTerm?.value,
                // //     }
                // //     :
                // //     {
                // //         hide: (field: FormlyFieldConfig) =>
                // //         field.model?.TotalObligationEntireTerm?.isValid === true  && field.model?.TotalObligationEntireTerm?.value !== '$ 0',
                // //         },
                // //     }
                // // },        
                // // {
                // // key: 'TotalCostOfBorrowing.value',
                // // type: 'agreement-currency', 
                // // className: customFieldClass,
                // // props: {
                // //     label: 'Total Cost Of Borrowing',
                // //     appearance: 'outline', 
                // //     floatLabel: 'always',
                // //     readonly: true,
                // // },
                // // expressions: {                                                       
                // //     ...(updateAgreement) ?
                // //         {
                // //             'props.required': 'model.TotalCostOfBorrowing?.required',
                // //             'props.textValue': (field: FormlyFieldConfig) => field.model?.TotalCostOfBorrowing?.value,
                // //         }
                // //         :
                // //         {
                // //             hide: (field: FormlyFieldConfig) =>
                // //             field.model?.TotalCostOfBorrowing?.isValid === true,
                // //         },
                // //     }
                // // },      
                {
                key: 'LoanDate.value',
                type: 'missing-value', 
                className: customFieldClass,
                props: {
                    label: 'Funded Date',
                    appearance: 'outline', 
                    floatLabel: 'always',
                    readonly: true,
                },
                expressions: {                                                      
                    ...(updateAgreement) ?
                        {
                            'props.required': 'model.LoanDate?.required',
                            'props.textValue': (field: FormlyFieldConfig) => field.model?.LoanDate?.value,
                        }
                        :
                        {
                            hide: (field: FormlyFieldConfig) =>
                            field.model?.LoanDate?.isValid === true,
                        },
                    }
                },    
                {
                key: 'FirstPaymentDate.value',
                type: 'missing-value', 
                className: customFieldClass,
                props: {
                    label: 'Start Date',
                    appearance: 'outline', 
                    floatLabel: 'always',
                    readonly: true,
                },
                expressions: {                                                     
                    ...(updateAgreement) ?
                        {
                            'props.required': 'model.FirstPaymentDate?.required',
                            'props.textValue': (field: FormlyFieldConfig) => field.model?.FirstPaymentDate?.value,
                        }
                        :
                        {
                            hide: (field: FormlyFieldConfig) =>
                            field.model?.FirstPaymentDate?.isValid === true,
                        },
                    }
                },  
                // // {
                // // key: 'LastPaymentDate.value',
                // // type: 'missing-value', 
                // // className: customFieldClass,
                // // props: {
                // //     label: 'Maturity Date',
                // //     appearance: 'outline', 
                // //     floatLabel: 'always',
                // //     readonly: true,
                // // },
                // // expressions: {                                                     
                // //     ...(updateAgreement) ?
                // //     {
                // //         'props.required': 'model.LastPaymentDate?.required',
                // //         'props.textValue': (field: FormlyFieldConfig) => field.model?.LastPaymentDate?.value,
                // //     }
                // //     :
                // //     {
                // //         hide: (field: FormlyFieldConfig) =>
                // //         field.model?.LastPaymentDate?.isValid === true,
                // //         },
                // //     }
                // // },
                // // {
                // // key: 'NSFFee.value',
                // // type: 'missing-value', 
                // // className: customFieldClass,
                // // props: {
                // //     label: 'NSF Fee',
                // //     appearance: 'outline', 
                // //     floatLabel: 'always',
                // //     readonly: true,
                // //     textValue: ''
                // // },
                // // expressions: {                                                          
                // //     ...(updateAgreement) ?
                // //     {
                // //         'props.required': 'model.NSFFee?.required',
                // //         'props.textValue': (field: FormlyFieldConfig) => field.model?.NSFFee?.value,
                // //         }
                // //     :
                // //     {
                // //         hide: (field: FormlyFieldConfig) =>
                // //         field.model?.NSFFee?.isValid === true,
                // //         },
                // //     }
                // // },                
                // // {
                // // key: 'TotalLegalFeeWithoutHST.value',
                // // type: 'missing-value', 
                // // className: customFieldClass,
                // // props: {
                // //     label: 'Saha',
                // //     appearance: 'outline', 
                // //     floatLabel: 'always',
                // //     readonly: true,
                // // },
                // // expressions: {                                                    
                // //     ...(updateAgreement) ?
                // //     {
                // //         'props.required': 'model.TotalLegalFeeWithoutHST?.required',
                // //         'props.textValue': (field: FormlyFieldConfig) => field.model?.TotalLegalFeeWithoutHST?.value,
                // //         hide: (field: FormlyFieldConfig) =>
                // //         field.model?.HasSaha?.value !== 'Yes',
                // //     }
                // //     :
                // //     {
                // //         hide: (field: FormlyFieldConfig) =>
                // //         field.model?.TotalLegalFeeWithoutHST?.isValid === true,
                // //         },
                // //     }
                // // },               
                // // {
                // // key: 'TotalHST.value',
                // // type: 'missing-value', 
                // // className: customFieldClass,
                // // props: {
                // //     label: 'HST',
                // //     appearance: 'outline', 
                // //     floatLabel: 'always',
                // //     readonly: true,
                // // },
                // // expressions: {                                                    
                // //     ...(updateAgreement) ?
                // //     {
                // //         'props.required': 'model.TotalHST?.required',
                // //         'props.textValue': (field: FormlyFieldConfig) => field.model?.TotalHST?.value,
                // //         hide: (field: FormlyFieldConfig) =>
                // //         field.model?.HasSaha?.value !== 'Yes',
                // //     }
                // //     :
                // //     {
                // //         hide: (field: FormlyFieldConfig) =>
                // //         field.model?.TotalHST?.isValid === true,
                // //         },
                // //     }
                // // },
                // // {
                // // key: 'LegalFee.value',
                // // type: 'missing-value', 
                // // className: customFieldClass,
                // // props: {
                // //     label: 'Total Legal Fee',
                // //     appearance: 'outline', 
                // //     floatLabel: 'always',
                // //     readonly: true,
                // // },
                // // expressions: {                                                    
                // //     ...(updateAgreement) ?
                // //     {
                // //         'props.required': 'model.LegalFee?.required',
                // //         'props.textValue': (field: FormlyFieldConfig) => field.model?.LegalFee?.value,
                // //         hide: (field: FormlyFieldConfig) =>
                // //         field.model?.HasSaha?.value !== 'Yes',
                // //     }
                // //     :
                // //     {
                // //         hide: (field: FormlyFieldConfig) =>
                // //         field.model?.LegalFee?.isValid === true,
                // //         },
                // //     }
                // // },                
                {
                    key: 'DisplayDOF',
                    type: 'table',
                    className: 'col-12 field-sm',
                    props: {
                        label: "Disbursement of Funds",
                        columns: [
                            { key: 'payeeName', label: 'Payee Name' },
                            { key: 'accountNumber', label: 'Account Number' },
                            { key: 'accountBalance', label: 'Account Balance' },
                        ],
                    }
                }, 
                {
                key: 'Amount.value',
                type: 'agreement-currency',
                className: 'col-12 field-sm',
                props: {
                    label: 'Total',
                    appearance: 'outline',
                    floatLabel: 'always',
                    readonly: true,
                    inline: true,
                },
                expressions: {                                                     
                    ...(updateAgreement) ?
                    {
                        'props.required': 'model.Amount?.required',
                        'props.textValue': (field: FormlyFieldConfig) => field.model?.Amount?.value,
                    }
                    :
                    {
                        hide: (field: FormlyFieldConfig) =>
                        field.model?.Amount?.isValid === true,
                        },
                    }
                },      
                {
                    type: 'calc-button',
                    props: {
                        text: 'Edit',
                        onClick: (field: FormlyFieldConfig) => {
                            options?.onUpdate?.(field.model, true);
                        }
                    },
                    expressions: {
                        'props.color': (field: FormlyFieldConfig) => hasMissingFundedDetails(field) ? 'warn' : 'primary',
                    }
                },
            ]
        }
    ]
}